export enum FontPoppins {
  'THIN' = 'Poppins_100Thin',
  'THIN_ITALIC' = 'Poppins_100Thin_Italic',
  'EXTRALIGHT' = 'Poppins_200ExtraLight',
  'LIGHT' = 'Poppins_300Light',
  'REGULAR' = 'Poppins_400Regular',
  'MEDIUM' = 'Poppins_500Medium',
  'SEMIBOLD' = 'Poppins_600SemiBold',
  'BOLD' = 'Poppins_700Bold',
  'EXTRABOLD' = 'Poppins_800ExtraBold',
  'BLACK' = 'Poppins_900Black',
}
